import {
  STORE_FinaleSelelctCartMerchantNZone,
  STORE_CartCheckoutData,
  STORE_SHEDULEDateNTime,
  STORE_PROMOTIONS,
  STORE_Addons,
  STORE_Cart,
} from "../database/store-names";
import { CLEAR_CART_MEMORY_CACHE } from "../database/store-data";
import { GET_CART_COUNT } from "./funtion";
import { ENCRYPT_STORAGE } from "../config/config";
import { dto_cart_checkout } from "../classes/dto-cart-checkout";
import { dto_common } from "../classes/dto-common";

export const clearCartAfterOrderSuccess = async () => {
  dto_common.SCHEDULEDDATE = "";
  dto_common.SCHEDULEDTIME = "";

  ENCRYPT_STORAGE.removeMultipleItems([
    STORE_Cart,
    STORE_Addons,
    STORE_FinaleSelelctCartMerchantNZone,
    STORE_PROMOTIONS,
    STORE_SHEDULEDateNTime,
    STORE_CartCheckoutData,
  ]);

  CLEAR_CART_MEMORY_CACHE();
  await GET_CART_COUNT([]);

  dto_cart_checkout.Cart = [];
  dto_cart_checkout.Total = 0;
  dto_cart_checkout.TaxTotal = 0;
  dto_cart_checkout.ServiceCharge = 0;
  dto_cart_checkout.DiscountTotal = 0;
  dto_cart_checkout.RowDiscountTotal = 0;
  dto_cart_checkout.SubTotal = 0;
  dto_cart_checkout.DisplaySubtotal = 0;
  dto_cart_checkout.PromoGuid = 0;
  dto_cart_checkout.PromoCODE = "";
  dto_cart_checkout.PromoHeader = "";
  dto_cart_checkout.DiscountPersentage = 0;
  dto_cart_checkout.XMLTaxDoc = [];
  dto_cart_checkout.Comment = "";
};
